module.exports = __webpack_public_path__ + "img/star-fill.d3fa52f0.png";